var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticStyle:{"margin":"-10px"},attrs:{"current-page":_vm.current,"page-size":_vm.size,"total":_vm.total,"page-sizes":[100, 200, 300, 400],"layout":"total, sizes, prev, pager, next, jumper"},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }